export default "__VITE_PUBLIC_ASSET__d11617fc__"